(()=> {
  const qs=(s,r=document)=>r.querySelector(s);
  const qsa=(s,r=document)=>Array.from(r.querySelectorAll(s));

  // ---------------------------
  // Luxe accordions
  // ---------------------------
  qsa('[data-pd-accordion]').forEach(root=>{
    const trigger = qs('[data-pd-accordion-trigger]', root);
    const panel = qs('[data-pd-accordion-panel]', root);
    if (!trigger || !panel) return;

    const setOpen = (open) => {
      root.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Smooth max-height transition (use scrollHeight)
      if (open){
        panel.hidden = false;
        requestAnimationFrame(()=>{
          panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        requestAnimationFrame(()=>{
          panel.style.maxHeight = '0px';
        });
        window.setTimeout(()=>{ panel.hidden = true; }, 360);
      }
    };

    // init closed
    trigger.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = '0px';
    panel.hidden = true;

    trigger.addEventListener('click', ()=>{
      const open = !root.classList.contains('is-open');
      setOpen(open);
    });
  });


  // Open the review accordion from the top product link, even when the product has no reviews yet.
  qsa('[data-open-product-reviews]').forEach(link => {
    link.addEventListener('click', (event) => {
      const reviewAccordion = qs('.pd-accordion--reviews');
      const reviewTrigger = reviewAccordion && qs('[data-pd-accordion-trigger]', reviewAccordion);
      if (!reviewAccordion || !reviewTrigger) return;
      event.preventDefault();
      if (!reviewAccordion.classList.contains('is-open')) reviewTrigger.click();
      window.setTimeout(() => {
        reviewAccordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 80);
    });
  });

  // ---------------------------
  // Sticky ATC (mobile)
  // ---------------------------
  const sticky = qs('[data-pd-sticky-atc]');
  const primaryAtc = qs('[data-pd-primary-atc]');
  if (sticky && primaryAtc){
    const show = (v)=>sticky.classList.toggle('is-visible', !!v);

    const io = new IntersectionObserver((entries)=>{
      entries.forEach(en=>{
        // If primary ATC is visible, hide sticky; if not visible, show sticky
        show(!en.isIntersecting);
      });
    }, { threshold: 0.1 });
    io.observe(primaryAtc);

    const stickyBtn = qs('[data-pd-sticky-add]', sticky);
    if (stickyBtn){
      stickyBtn.addEventListener('click', (e)=>{
        e.preventDefault();
        // Trigger normal product form submit for compatibility with apps
        primaryAtc.click();
      });
    }
  }

  // Update sticky info on variant change
  const variantSelect = qs('select[name="id"]');
  const variantDataEl = qs('[data-pd-variant-data]');
  const stickyPriceEl = sticky && qs('[data-pd-sticky-price]', sticky);
  const stickyThumbEl = sticky && qs('[data-pd-sticky-thumb]', sticky);
  const mainPriceEl = qs('[data-product-price]');
  const mainCompareEl = qs('[data-product-compare]');
  const availabilityEl = qs('[data-product-availability]');
  const buyNowBtn = qs('[data-buy-now]');
  const productWhatsAppBtn = qs('[data-whatsapp-source="product-cart"], [data-whatsapp-source="availability"]');
  let variantData=[];
  if (variantDataEl){
    try{ variantData = JSON.parse(variantDataEl.textContent || '[]'); }catch(_){ variantData=[]; }
  }
  const setStickyForVariant = (variantId) => {
    if (!variantId) return;
    const v = variantData.find(x=>String(x.id)===String(variantId));
    if (!v) return;
    if (stickyPriceEl && v.price_formatted) stickyPriceEl.textContent = v.price_formatted;
    if (mainPriceEl && v.price_formatted) mainPriceEl.textContent = v.price_formatted;
    if (mainCompareEl){
      if (v.compare_at_price_formatted){
        mainCompareEl.innerHTML = `<s>${v.compare_at_price_formatted}</s>`;
        mainCompareEl.hidden = false;
      } else {
        mainCompareEl.innerHTML = '';
        mainCompareEl.hidden = true;
      }
    }
    qsa('[data-variant-price-row]').forEach((row)=>{
      row.classList.toggle('is-active', String(row.getAttribute('data-variant-id')) === String(variantId));
    });
    if (stickyThumbEl && v.thumb_src) stickyThumbEl.src = v.thumb_src;
    const stickyBtn = sticky ? qs('[data-pd-sticky-add]', sticky) : null;
    if (stickyBtn){
      stickyBtn.disabled = v.available === false;
      stickyBtn.textContent = v.available === false ? 'Sold out' : 'Add to cart';
    }
    if (primaryAtc){
      primaryAtc.disabled = v.available === false;
      primaryAtc.textContent = v.available === false ? 'Sold out' : 'Add to cart';
    }
    if (buyNowBtn){
      buyNowBtn.disabled = v.available === false;
      buyNowBtn.hidden = v.available === false;
    }
    if (productWhatsAppBtn){
      productWhatsAppBtn.setAttribute('data-whatsapp-source', v.available === false ? 'availability' : 'product-cart');
      productWhatsAppBtn.innerHTML = v.available === false ? '<span>Ask about</span><span>availability</span>' : '<span>Order Via</span><span>WhatsApp</span>';
      if (window.PDWhatsApp && typeof window.PDWhatsApp.refresh === 'function') {
        window.PDWhatsApp.refresh(window.__PD_INITIAL_CART || null);
      }
    }
    if (availabilityEl){
      const qty = Number(v.inventory_quantity || 0);
      const managed = !!v.inventory_management;
      availabilityEl.classList.toggle('is-unavailable', v.available === false);
      if (v.available === false) availabilityEl.textContent = 'Sold out';
      else if (managed && qty > 0 && qty <= 3) availabilityEl.textContent = `Only ${qty} left — order soon`;
      else availabilityEl.textContent = 'In stock — ready to order';
    }
  };
  const syncVariantPills = (variantId) => {
    qsa('[data-variant-pill]').forEach((pill) => {
      const active = String(pill.getAttribute('data-variant-id')) === String(variantId);
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };
  if (variantSelect){
    setStickyForVariant(variantSelect.value);
    syncVariantPills(variantSelect.value);
    variantSelect.addEventListener('change', ()=>{
      setStickyForVariant(variantSelect.value);
      syncVariantPills(variantSelect.value);
      if (window.PDWhatsApp && typeof window.PDWhatsApp.refresh === 'function') {
        window.PDWhatsApp.refresh(window.__PD_INITIAL_CART || null);
      }
    });
  }
  qsa('[data-variant-pill]').forEach((pill) => {
    pill.addEventListener('click', () => {
      const variantId = pill.getAttribute('data-variant-id');
      if (!variantSelect || !variantId) return;
      variantSelect.value = variantId;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ---------------------------
  // Product zoom (loupe + modal)
  // ---------------------------
  const mainImg = qs('[data-pd-main-image]');
  const loupe = qs('[data-pd-loupe]');
  const zoomOpen = qs('[data-pd-zoom-open]');
  const modal = qs('[data-pd-zoom-modal]');
  const modalImg = modal && qs('[data-pd-zoom-img]', modal);
  const stage = modal && qs('[data-pd-zoom-stage]', modal);
  const closeBtns = modal ? qsa('[data-pd-zoom-close]', modal) : [];

  const getZoomSrc = () => {
    if (!mainImg) return '';
    return mainImg.getAttribute('data-zoom-src') || mainImg.getAttribute('src') || '';
  };

  const openModal = () => {
    if (!modal || !modalImg) return;
    const src = getZoomSrc();
    if (!src) return;
    modalImg.src = src;
    modalImg.alt = mainImg ? (mainImg.getAttribute('alt') || '') : '';
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    resetTransform();
  };

  const closeModal = () => {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  };

  if (zoomOpen) zoomOpen.addEventListener('click', (e)=>{ e.preventDefault(); openModal(); });
  if (mainImg) mainImg.addEventListener('click', (e)=>{ 
    // On desktop, allow click to zoom too
    if (window.matchMedia('(pointer:fine)').matches){ e.preventDefault(); openModal(); }
  });
  closeBtns.forEach(b=>b.addEventListener('click', (e)=>{e.preventDefault(); closeModal();}));
  if (modal){
    modal.addEventListener('click', (e)=>{
      const hit = e.target && e.target.closest ? e.target.closest('[data-pd-zoom-close]') : null;
      if (hit) closeModal();
    });
    document.addEventListener('keydown', (e)=>{
      if (!modal.hidden && e.key === 'Escape') closeModal();
    });
  }

  // Desktop loupe (jeweler's loupe)
  const canHover = window.matchMedia('(hover:hover)').matches && window.matchMedia('(pointer:fine)').matches;
  if (canHover && mainImg && loupe){
    const loupeSize = () => loupe.offsetWidth || 160;

    const computeZoom = () => {
      const r = mainImg.getBoundingClientRect();
      const naturalW = mainImg.naturalWidth || 0;
      const ratio = naturalW && r.width ? (naturalW / r.width) : 2.6;
      return Math.max(2, Math.min(3.5, ratio));
    };

    const activate = () => {
      const src = getZoomSrc();
      if (!src) return;
      const r = mainImg.getBoundingClientRect();
      const zoom = computeZoom();
      loupe.style.backgroundImage = `url("${src}")`;
      loupe.style.backgroundSize = `${Math.round(r.width * zoom)}px ${Math.round(r.height * zoom)}px`;
      loupe.classList.add('is-active');
    };
    const deactivate = () => loupe.classList.remove('is-active');

    const move = (e) => {
      const r = mainImg.getBoundingClientRect();
      const x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      const y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));

      const s = loupeSize();
      // Clamp loupe inside image bounds
      const lx = Math.max(s/2, Math.min(r.width - s/2, x * r.width));
      const ly = Math.max(s/2, Math.min(r.height - s/2, y * r.height));

      loupe.style.left = (lx - s/2) + 'px';
      loupe.style.top  = (ly - s/2) + 'px';
      loupe.style.backgroundPosition = `${x*100}% ${y*100}%`;
    };

    mainImg.addEventListener('mouseenter', activate);
    mainImg.addEventListener('mouseleave', deactivate);
    mainImg.addEventListener('mousemove', move);
  }

  // Modal pinch/zoom + pan (pointer events)
  let scale=1, tx=0, ty=0;
  const pointers = new Map();
  let startDist=0, startScale=1, startMid=null, startTx=0, startTy=0;
  let panStartPt = null;

  const applyTransform = () => {
    if (!modalImg) return;
    modalImg.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`;
  };
  const resetTransform = () => {
    scale=1; tx=0; ty=0;
    if (modalImg) modalImg.style.transformOrigin = 'center center';
    applyTransform();
  };

  const dist = (a,b)=>Math.hypot(a.x-b.x, a.y-b.y);
  const mid = (a,b)=>({x:(a.x+b.x)/2, y:(a.y+b.y)/2});

  if (stage && modalImg){
    stage.addEventListener('wheel', (e)=>{
      if (modal.hidden) return;
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.08 : 0.08;
      scale = Math.max(1, Math.min(4, scale + delta));
      applyTransform();
    }, { passive:false });

    stage.addEventListener('pointerdown', (e)=>{
      if (modal.hidden) return;
      stage.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, {x:e.clientX, y:e.clientY});
      if (pointers.size === 2){
        const pts=[...pointers.values()];
        startDist = dist(pts[0], pts[1]);
        startScale = scale;
        startMid = mid(pts[0], pts[1]);
        startTx = tx; startTy = ty;
      } else if (pointers.size === 1){
        startTx = tx; startTy = ty;
        panStartPt = {x:e.clientX, y:e.clientY};
      }
    });

    stage.addEventListener('pointermove', (e)=>{
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, {x:e.clientX, y:e.clientY});

      if (pointers.size === 2){
        const pts=[...pointers.values()];
        const d = dist(pts[0], pts[1]);
        const m = mid(pts[0], pts[1]);
        const nextScale = Math.max(1, Math.min(4, startScale * (d / (startDist || d))));
        scale = nextScale;

        // keep center stable
        if (startMid){
          tx = startTx + (m.x - startMid.x);
          ty = startTy + (m.y - startMid.y);
        }
        applyTransform();
      } else if (pointers.size === 1 && scale > 1){
        const p = pointers.get(e.pointerId);
        if (!p) return;
        const sx = panStartPt ? panStartPt.x : p.x;
        const sy = panStartPt ? panStartPt.y : p.y;
        const dx = p.x - sx;
        const dy = p.y - sy;
        tx = startTx + dx;
        ty = startTy + dy;
        applyTransform();
      }
    });

    const endPointer = (e)=>{
      if (pointers.has(e.pointerId)) pointers.delete(e.pointerId);

      if (pointers.size < 2){
        startDist = 0;
        startMid = null;
      }
      if (pointers.size === 0){
        panStartPt = null;
      }
      if (pointers.size === 1){
        // allow a smooth transition from pinch to pan
        const remaining = [...pointers.values()][0];
        panStartPt = remaining ? {x:remaining.x, y:remaining.y} : null;
        startTx = tx; startTy = ty;
      }
    };
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
  }

})();